import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class FilterToggle extends ThemeComponent {
    @Prop className!: string;
    @Prop target!: string;
    @Ref() button!: HTMLButtonElement;

    init() {

        // Init click event listeners
        this.initClickEventListener();

        // Init mobile filter breakpoint check
        this.matchMedia();
    }

    initClickEventListener() {
        this.$listen(this.button, 'click', () => {
            alert('alert');

            // Check filters exists
            const filters = document.querySelector(`${this.target}`);
            if (!filters) {
                return;
            }

            // Body class
            document.body.classList.toggle('collection-filters-active');

            // Filters class
            filters.classList.toggle(`${this.target}--active`);
        });
    }

    matchMedia() {
        // Remove product filters active active if greater than mobile breakpoint
        const mmBreakpoint = window.matchMedia(`(max-width: 768px)`);

        // Check breakpoint, remove product filters classes if required
        const breakpointChecker = () => {
            if (!mmBreakpoint.matches) {

                // Only run if filters are active
                if (!document.body.classList.contains('collection-filters-active')) {
                    return;
                }

                // Check product filters exists
                const filters = document.querySelector(`${this.target}`);
                if (!filters) {
                    return;
                }

                // Body class
                document.body.classList.remove('collection-filters-active');

                // Filters class
                filters.classList.remove(`${this.target}--active`);
            }
        };

        // Init listener and initial check
        breakpointChecker();
        mmBreakpoint.addListener(breakpointChecker);
    }
}
